module.exports = __webpack_public_path__ + "media/images/company/company_04_sub-3f1ba6d4535d9ffa406ff49fd2eb15f1.jpg";